/* Sweet Crème — motion polish. Adds scroll-reveal with stagger, only when the
   visitor hasn't requested reduced motion. No-ops gracefully otherwise. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
  document.documentElement.classList.add('sc-motion');

  function init() {
    function tag(el, i) {
      if (!el) return;
      el.setAttribute('data-sc-reveal', '');
      if (i != null) el.style.setProperty('--sc-reveal-i', i);
    }

    // Single-element reveals.
    [
      '.sc-trio__eyebrow', '.sc-trio__heading',
      '.sc-fc__titles', '.sc-fc__tabs',
      '.sc-story__art', '.sc-story__copy',
      '.sc-cta__lead-col', '.sc-glance',
      '.sc-media__head', '.sc-media__profile', '.sc-media__highlights', '.sc-media__foot'
    ].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { tag(el); });
    });

    // Staggered groups: reveal each child in sequence.
    [
      ['.sc-trio__grid', ':scope > *'],
      ['.sc-policy__inner', ':scope > *'],
      ['.sc-media__feed', ':scope > *']
    ].forEach(function (pair) {
      document.querySelectorAll(pair[0]).forEach(function (group) {
        var kids = group.querySelectorAll(pair[1]);
        kids.forEach(function (kid, i) { tag(kid, i); });
      });
    });

    var targets = document.querySelectorAll('[data-sc-reveal]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
